import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    containerStyle,
    formContainerStyle,
    headerStyle,
    titleStyle,
    formStyle,
    buttonStyle,
    footerTextStyle
} from '../styles/globalStyles';

const CheckoutCancel: React.FC = () => {
    const navigate = useNavigate();

    return(
        <div style={containerStyle}>
            <div style={formContainerStyle}>
                <div style={headerStyle}>
                    <h1 style={titleStyle}>Checkout Canceled</h1>
                </div>
                <div style={formStyle}>
                    <div style={footerTextStyle}>
                        Your checkout was canceled. You can try again anytime.
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: 24 }}>
                        <button type="button" style={buttonStyle} onClick={() => navigate( '/' )}>
                            Return to Home
                        </button>
                        <button
                            type="button"
                            style={{ ...buttonStyle, background: 'transparent', border: '1px solid #22d3ee', color: '#22d3ee' }}
                            onClick={() => navigate( '/register' )}
                        >
                            Create Account
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CheckoutCancel;
